import React, { useEffect, useState } from "react";
import "../../../css/astrologer-status.css";
import { FaClock } from "react-icons/fa6";
import { IoMdCall } from "react-icons/io";
import { getData } from "../../../ApiMethods/ApiMethods";

const statusClasses = {
  Online: "Online",
  Offline: "Offline",
  Busy: "Busy",
  Free: "Free",
};

export default function AstrologerLiveStatus() {
  const [astrodatas, setAstrodatas] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");


  const astrologerstatusdata = async () => {
    try {
      const res = await getData("Astrologer/AstrologerLiveStatus");
      setAstrodatas(res || []);
    } catch (err) {
      console.error("Failed to fetch astrologer data:", err);
    }
  };

  useEffect(() => {
    astrologerstatusdata();
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      setAstrodatas((prev) =>
        prev.map((astro) =>
          astro.Status === "Busy"
            ? { ...astro, waitTime: Math.floor(Math.random() * 10 + 1) + " min" }
            : astro
        )
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);


  const filteredAstrologers = astrodatas.filter((astro) => {
    const matchesSearch =
      astro.DisplayName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      astro.ID?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
      astro.RegMobileNo?.includes(searchTerm);

    const matchesStatus =
      filterStatus === "All" || astro.Status === filterStatus;

    return matchesSearch && matchesStatus;
  });

  return (
    <div className="main-container">
      <h2 className="page-title display-5 mb-5">
        Astrologer Live Status Panel
      </h2>


      <div className="search-container row g-3 mb-4">
        <div className="col-md-8 col-lg-6 mx-auto">
          <div className="input-group">
            <input
              type="text"
              className="form-control form-control-lg custom-focus"
              placeholder="Search by Name, ID, or Mobile"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select
              className="form-select form-select-lg custom-focus"
              style={{ maxWidth: "200px" }}
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="All">All Statuses</option>
              <option value="Online">Online</option>
              {/* <option value="Busy">Busy</option>
              <option value="Free">Free</option> */}
              <option value="Offline">Offline</option>
            </select>
          </div>
        </div>
      </div>


      <div className="row g-4">
        {filteredAstrologers.length > 0 ? (
          filteredAstrologers.map((astro) => (
            <div key={astro.ID} className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div className="astrologer-card shadow-sm h-100">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3 className="astrologer-name mb-0">{astro.DisplayName}</h3>
                  <span style={{ color: "#5d3899ff" }}
                    className={`status-badge ${astro.Status === "Online"
                        ? "bg-success"
                        : astro.Status === "Offline"
                          ? "bg-danger"
                          : astro.Status === "Busy"
                            ? "bg-warning"
                            : "bg-secondary"
                      }`}
                  >
                    {astro.Status}
                  </span>

                </div>

                <p className="astrologer-detail">
                  <strong>ID:</strong> {astro.ID}
                </p>
                <p className="astrologer-detail mb-3">
                  <strong>Mobile:</strong>{" "}
                  <i className="fa fa-mobile" aria-hidden="true"></i>{" "}
                  {astro.RegMobileNo}
                </p>


                {astro.IsBusy === "True" ? (
                  <span
                    className="px-3 py-1 rounded-pill text-white fw-bold"
                    style={{ backgroundColor: "#9c8786ff" }}
                  >
                    Busy
                  </span>
                ) : (
                  <span
                    className="px-3 py-1 rounded-pill text-white fw-bold"
                    style={{ backgroundColor: "#1a201bff" }}
                  >
                    No Busy
                  </span>
                )}

              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-muted">No astrologers found.</div>
        )}
      </div>
    </div>
  );
}
